import { ModuleConfig } from '../components/Module';

export const moduleConfigBaseUrlNonProd = 'https://hdev.nonprod.cmcmarketsinvest.com';

const moduleConfigRegistryUrls: Record<string, string> = {};
let moduleBaseUrl = '';

/**
 * Generate the module config without using a manifest
 * @param appName The app name the module is hosted in, usually the repo name of the module
 * @param module The name of the module exposed by the app
 * @param baseUrl The base url that modules are served from
 * @returns the module config
 */
export const moduleConfigFactory = (appName: string, module: string) => {
  if (!moduleConfigRegistryUrls[appName]) {
    moduleConfigRegistryUrls[appName] = `${moduleBaseUrl}/${appName}/v/latest/remoteEntry.js`;
  }
  const moduleAppName = appName.replace(/-/g, '_');
  const moduleConfig: ModuleConfig = {
    appName: moduleAppName,
    module,
    url: moduleConfigRegistryUrls[appName]
  };
  return moduleConfig;
};

/**
 * Register a URL to be used for a module config
 * @param appName The app name the module is hosted in, usually the repo name of the module
 * @param url The url the module is served from
 */
export const registerModuleConfigUrl = (appName: string, url: string) => {
  moduleConfigRegistryUrls[appName] = url;
};

/**
 * Registers a base module url
 * @param baseUrl The base url to use for modules, if null will return currently registered url
 * @returns currently configured module base url
 */
export const registerModuleBaseUrl = (baseUrl?: string) => {
  if (baseUrl) {
    moduleBaseUrl = baseUrl;
  }
  return moduleBaseUrl;
};
